import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.05 2.385c.866-1.503 3.034-1.503 3.9 0l9.357 16.242c.864 1.5-.219 3.373-1.95 3.373H2.642C.912 22-.17 20.127.693 18.627zM12 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-8.5A1.5 1.5 0 0 0 10.5 9v3.5a1.5 1.5 0 0 0 3 0V9A1.5 1.5 0 0 0 12 7.5"
    }, null, -1)
  ]))]))
}
export default { render: render }